export default __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu4WxKOzY.woff2";